import { connect } from 'react-redux';
import DeleteHoldingModal, {
  DeleteHoldingModalProps,
} from '@/components/DeprecatedPortfolio/components/DeleteHoldingModal';
import { hideDeleteHoldingModal } from '@/components/DeprecatedPortfolio/components/DeleteHoldingModal/redux';
import type { PortfolioState } from '@/components/DeprecatedPortfolio/redux/interface';

import { removeCompany } from '@components/AddRemoveCompany/redux/routines';

const mapStateToProps = ({
  portfolio: {
    deleteHoldingModal: {
      companyId,
      companyName,
      portfolioId,
      uniqueSymbol,
      deleteHoldingModalStatus,
    },
  },
}: {
  portfolio: PortfolioState;
}): Partial<DeleteHoldingModalProps> => ({
  companyId,
  companyName,
  portfolioId,
  uniqueSymbol,
  deleteHoldingModalStatus,
});

const mapDispatchToProps = (dispatch): Partial<DeleteHoldingModalProps> => {
  return {
    onConfirm: (data) => dispatch(removeCompany.trigger(data)),
    onClose: () => dispatch(hideDeleteHoldingModal()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteHoldingModal);
